import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';

import { FormHelperService } from '../../../services/form-helper.service';
import { DropdownService } from '../../../services/dropdown-service';
import { forkJoin } from 'rxjs';
import { LookupItem } from '../../../components/utils/models/lookupItem';
import { RichFormComponent } from '../../../components/library/rich-form/rich-form.component';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss','../product-form.css']
})
export class AddressComponent {
  @Input() formGroupName!: string;
  @Output() isDataChanged = false;
  @Output() notifyContainerDataChanged = new EventEmitter<any>();

  addressForm!: FormGroup;

  formUiWidgets!: Record<string, any>[] ;
  savedAddressData!: Record<string, any>;
  addressData!: Record<string, any>;
  isLoading = false;
  isContentScrolled = false;
  countriesList! : Array<LookupItem>;
  isAddBtnDisabled = true;
  @ViewChild('addressFormComponent') addressFormComponent!: RichFormComponent;

  constructor(
    private fb: FormBuilder,
    private formGroupDirective: FormGroupDirective,
    private _formHelper: FormHelperService,
    private _DropdownService : DropdownService) 
    {


    }


  ngOnInit(): void {

    this.addressForm = this.formGroupDirective.control.get(this.formGroupName) as FormGroup;
    this._DropdownService
      .getCountries()
      .subscribe((value) =>
     {
        this.countriesList = value;
        this.countriesList = this.countriesList.sort((a, b) => {
          return a.name.localeCompare(b.name)
        });
        this.addressData = this._DropdownService.getDefaultAddressData();
        this.formUiWidgets = this.getFormControls();

        this.addressForm.patchValue({
          'country': this._DropdownService.getDefaultAddressData()['country']
        });
    });

   }

  getFormControls(){
    return [
      
      { 
        label: 'Street Name and Number',
        dataField: 'numberAndStreetname',
        validators: [
          { type: 'required' }
        ],
        colSpan: 1,
          width: '150px',
          FormType : 'Address'
      },
      { 
        label: 'Complex',
        dataField: 'unitNumberAndComplex', 
        colSpan: 1,
          width: '150px',
          FormType : 'Address'
      },
      { 
        label: 'Suburb',
        validators: [
          { type: 'required' }
        ],
        dataField: 'suburb', 
        colSpan: 1 , 
        width: '150px',
        FormType : 'Address'
      },
      { 
        label: 'City',
        validators: [
          { type: 'required' }
        ],
        dataField: 'city', 
        colSpan: 1,
          width: '150px',
          FormType : 'Address'
      },
      { 
        label: 'Code',
        editorType: 'dxNumberBox',
        validators: [
          { type: 'required' }
        ],
        editorOptions: {
          format: '#',
        },
        dataField: 'code',
        colSpan: 1,
        width: '150px',
        FormType : 'Address'
      },
      { 
        label: 'Country',
        validators: [
          { type: 'required' }
        ],
        dataField: 'country',
        editorType: 'dxSelectBox', 
        colSpan: 2,
        width: '150px',
        itemsList: this.countriesList,
        FormType : 'Address'
      }
    ]
  }

  scroll({reachedTop = false}) {
    this.isContentScrolled = !reachedTop;
  }

  dataChanged(object) {

    if ('event' in object && object.event.dataField == 'country' && object.event.value == null)
    {

      this._DropdownService
        .getCountries()
        .subscribe((value) => {
          this.countriesList = value;
          this.countriesList = this.countriesList.sort((a, b) => {
            return a.name.localeCompare(b.name)
          });
          this.addressData = this._DropdownService.getDefaultAddressData();
          this.formUiWidgets = this.getFormControls();

          this.addressForm.patchValue({
            'country': this._DropdownService.getDefaultAddressData()['country'],
          });
        });
    }

    
    //set populated form field
   
    if ('event' in object) {
      
      if (typeof object.event.value === 'string' || object.event.value instanceof String) {

        let formValue: String = object.event.value;
        formValue = formValue.trim();

        this.addressForm.patchValue({
          [object.event.dataField]: formValue
        });
      }
      else {

        this.addressForm.patchValue({
          [object.event.dataField]: object.event.value
        });
      }
      
      
      
    }
    
    this.notifyContainerDataChanged.emit(object);
  }

  cancel() {

    this.addressFormComponent.clearForm();
    this.addressData = this._DropdownService.getDefaultAddressData();
    
  }

}
